import rowStyles from './TaskListRow.module.css';
import styles from './TaskListLoader.module.css';

export default function TaskListLoader() {
  return (
    <div className={`${rowStyles['grid-row']} ${styles['skeleton-row']}`}>
      <div className={`${rowStyles.cell} ${rowStyles['row-id']}`}>
        <div className={`${styles.pill} ${styles.idPill}`}>
          <span className={styles.icon} />
          <span className={styles.text} />
        </div>
      </div>

      <div className={`${rowStyles.cell} ${rowStyles['row-name']}`}>
        <div className={`${styles.pill} ${styles.namePill}`} />
      </div>

      <div className={`${rowStyles.cell} ${rowStyles['row-date']}`}>
        <div className={`${styles.pill} ${styles.datePill}`} />
      </div>

      <div className={`${rowStyles.cell} ${rowStyles['row-user']}`}>
        <div className={`${styles.pill} ${styles.userPill}`} />
      </div>

      <div className={`${rowStyles.cell} ${rowStyles['row-data']}`}>
        <div className={`${styles.pill} ${styles.dataPill}`} />
      </div>

      <div className={`${rowStyles.cell} ${rowStyles['row-devices']}`}>
        <div className={styles.devicesWrap}>
          <div className={styles.badge} />
          <div className={styles.badge} />
        </div>
      </div>

      <div className={`${rowStyles.cell} ${rowStyles['row-rounds']}`}>
        <div className={styles.roundsWrap}>
          <div className={styles.roundsNum} />
          <div className={styles.badgeSm} />
        </div>
      </div>

      <div className={`${rowStyles.cell} ${rowStyles['row-status']}`}>
        <div className={`${rowStyles['row-status-wrap']} ${styles.statusWrap}`}>
          <div className={styles.statusDot} />
          <div className={styles.statusText} />
          <div className={styles.statusArrow} />
        </div>
      </div>
    </div>
  );
}